import React, { useState } from 'react';

const faqData = [
    {
        question: "Mekânname'ye nasıl başlarım?",
        answer: "Uygulamaya başlamak için Anasayfa'daki 'Hemen Başla' butonuna tıklayarak fotoğraf yükleme sayfasına gidebilir veya rotalar sayfasından hazır rotaları inceleyebilirsiniz."
    },
    {
        question: "Yüklediğim fotoğrafların gizliliği güvende mi?",
        answer: "Evet, yüklediğiniz tüm fotoğraflar gizlilik politikamız kapsamında korunur. Fotoğraflarınız yalnızca yapay zeka analizleri için kullanılır ve izniniz olmadan paylaşılmaz."
    },
    {
        question: "Uygulama hangi tür tarihi mekanları tanıyabiliyor?",
        answer: "Uygulamamız, antik kentlerden Osmanlı dönemi yapılarına, tarihi çeşmelerden müzelerde sergilenen eserlere kadar geniş bir yelpazede tarihi ve kültürel mekanı tanıyabilme yeteneğine sahiptir."
    },
    {
        question: "Yapay zeka analizi ne kadar sürüyor?",
        answer: "Analiz süresi, fotoğrafın karmaşıklığına ve sunucu yoğunluğuna bağlı olarak değişiklik gösterebilir. Genellikle birkaç saniye içinde sonuç alırsınız."
    },
    {
        question: "Kendi rotamı oluşturabilir miyim?",
        answer: "Şu an için özel rota oluşturma özelliği geliştirme aşamasındadır. Ancak mevcut rotaları inceleyebilir, favorilerinize ekleyebilir ve tamamlayabilirsiniz."
    },
    {
        question: "Uygulamayı kullanmak ücretli mi?",
        answer: "Mekânname'nin temel özelliklerini ücretsiz olarak kullanabilirsiniz. İlerleyen dönemlerde ek özellikler için abonelik seçenekleri sunulabilir."
    }
];

const FAQPage = () => {
    // Akordiyonun açık olan elemanını yöneten state
    const [openIndex, setOpenIndex] = useState(null);

    // Bir sorunun açılıp kapanmasını sağlayan fonksiyon
    const toggleFAQ = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <div className="min-h-screen bg-gray-900 text-white font-inter py-16 px-4 sm:px-6 lg:px-8">
            <div className="max-w-4xl mx-auto">
                {/* Sayfa Başlığı ve Açıklaması */}
                <header className="text-center mb-12 md:mb-16">
                    {/* Revize edilmiş başlık stili */}
                    <h1 className="text-5xl md:text-6xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-teal-400 to-indigo-500 mb-4 drop-shadow-md">
                        Sıkça Sorulan Sorular
                    </h1>
                    <p className="text-lg text-gray-400 max-w-2xl mx-auto">
                        Uygulamamızla ilgili en çok merak edilen soruları bu bölümde bulabilirsiniz. Aradığınız cevabı bulamazsanız, lütfen bize ulaşın.
                    </p>
                </header>

                {/* Soru-Cevap Akordiyonu */}
                <div className="space-y-4">
                    {faqData.map((item, index) => (
                        <div
                            key={index}
                            className="bg-gray-800/40 backdrop-blur-sm rounded-xl overflow-hidden shadow-xl border border-gray-700 transition-all duration-300 hover:border-indigo-600"
                        >
                            <button
                                onClick={() => toggleFAQ(index)}
                                className="w-full flex items-center justify-between p-6 text-xl font-semibold text-white transition-colors duration-300 hover:bg-gray-700/50"
                            >
                                <span>{item.question}</span>
                                <i
                                    className={`fas fa-chevron-down transform transition-transform duration-300 ${openIndex === index ? 'rotate-180 text-teal-400' : 'text-indigo-400'}`}
                                ></i>
                            </button>

                            <div
                                className={`transition-all duration-500 ease-in-out ${openIndex === index ? 'max-h-screen opacity-100' : 'max-h-0 opacity-0'}`}
                            >
                                <div className="p-6 pt-4 text-gray-300 leading-relaxed text-base border-t border-gray-700">
                                    <p>{item.answer}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default FAQPage;